import React from 'react';
import { X, Phone, Clock, ExternalLink } from 'lucide-react';

const LocationDetails = ({ location, onClose, onFindOutMore, isMobile = false }) => {
  const ServiceBadge = ({ available, label }) => (
    <div className={`service-badge ${available ? 'service-available' : 'service-unavailable'}`}>
      {label}
    </div>
  );

  return (
    <div className={`location-details ${isMobile ? 'location-details-mobile' : ''}`}>
      <div className="location-details-header">
        <h3 className="location-details-title">{location.site}</h3>
        <button className="close-button" onClick={onClose}>
          <X size={20} />
        </button>
      </div>

      <div className="location-details-content">
        <div className="location-full-address">
          {location.operatingName && <p><strong>{location.operatingName}</strong></p>}
          <p>{location.address}</p>
        </div>

        <div className="detail-section">
          <h4>Contact Information</h4>
          <div className="contact-item">
            <Phone size={16} />
            <span>{location.phone}</span>
          </div>
          {location.website && (
            <div className="contact-item">
              <ExternalLink size={16} />
              <a href={`https://${location.website}`} target="_blank" rel="noopener noreferrer">
                {location.website}
              </a>
            </div>
          )}
        </div>

        <div className="detail-section">
          <h4>Opening Hours</h4>
          <div className="hours-item">
            <Clock size={16} />
            <div>
              <p><strong>Mon-Fri:</strong> {location.hours.weekdays}</p>
              <p><strong>Saturday:</strong> {location.hours.saturday}</p>
              <p><strong>Sunday:</strong> {location.hours.sunday}</p>
            </div>
          </div>
        </div>

        <div className="detail-section">
          <h4>Services Available</h4>
          <div className="services-grid">
            <ServiceBadge available={location.services.carVehicles} label="Cars" />
            <ServiceBadge available={location.services.mediumVans} label="Medium Vans" />
            <ServiceBadge available={location.services.largeVans} label="Large Vans" />
            <ServiceBadge available={location.services.diagnosticScans} label="Diagnostics" />
            <ServiceBadge available={location.services.adasCalibrations} label="ADAS" />
            <ServiceBadge available={location.services.wheelAlignment} label="Wheel Alignment" />
            <ServiceBadge available={location.services.alloyRepairs} label="Alloy Repairs" />
            <ServiceBadge available={location.services.bsiKitemark} label="BSI Certified" />
          </div>
        </div>

        <div className="detail-section">
          <h4>Facilities</h4>
          <p>Spray Booths: {location.facilities.sprayBooths}</p>
          <p>Total Bays: {location.facilities.totalBays}</p>
        </div>

        {location.courtesyCars.length > 0 && (
          <div className="detail-section">
            <h4>Courtesy Cars</h4>
            {location.courtesyCars.map((car, index) => (
              <p key={index}>• {car}</p>
            ))}
          </div>
        )}

        {(location.email.retail || location.email.parts || location.email.accounts) && (
          <div className="detail-section">
            <h4>Email Contacts</h4>
            {location.email.retail && (
              <p className="email-contact">Retail: {location.email.retail}</p>
            )}
            {location.email.parts && (
              <p className="email-contact">Parts: {location.email.parts}</p>
            )}
            {location.email.accounts && (
              <p className="email-contact">Accounts: {location.email.accounts}</p>
            )}
          </div>
        )}

        <div className="detail-actions">
          <button 
            className="action-button action-primary"
            onClick={() => onFindOutMore(location)}
          >
            Find out more
          </button>
          <button className="action-button action-secondary">Get directions</button>
        </div>
      </div>
    </div>
  );
};

export default LocationDetails;